import React, { Component } from 'react';

import { removeFile } from '../actions/files';

import { trackEvent } from '../services/events-tracker-service';

import FileContainer from '../containers/file-container';

import AttachmentThumb from './attachment-thumb';

export default class MessageAttachment extends Component {
    handleDelete = (id, name) => {
        trackEvent('FILE.DELETE', {
            via: 'Message',
            fileName: name
        });

        removeFile(this.props.id);
    }

    render() {
        return (
            <FileContainer id={typeof this.props.id === 'object' ? null : this.props.id}>
                <AttachmentThumb
                    association="Message"
                    filePreviewPath={this.props.filePreviewPath}
                    noRedirect={!this.props.filePreviewPath}
                    onDelete={this.handleDelete}
                    siblings={this.props.siblings}
                    selfEditOnly={true}
                />
            </FileContainer>
        );
    }
}

